import React, { useState } from 'react';
import '../App.css';

function USBControl({ setUsbPort, sendCommand }) {
    const [isConnected, setIsConnected] = useState(false);
    const [portInfo, setPortInfo] = useState('');

    const connectUSB = async () => {
        if (!navigator.serial) {
            alert("Web Serial is not supported in this browser. Please use Chrome or Edge.");
            return;
        }

        try {
            const port = await navigator.serial.requestPort();
            await port.open({ baudRate: 9600 });

            setUsbPort(port);
            setIsConnected(true);

            const info = port.getInfo();
            setPortInfo(`VID:${info.usbVendorId} PID:${info.usbProductId}`);

            console.log('USB Connected:', info);
        } catch (error) {
            console.error('USB connection error:', error);
            alert('Failed to connect to USB device: ' + error.message);
        }
    };

    const disconnectUSB = async () => {
        // Note: Fully closing the port in React can be tricky due to streams.
        // We'll mostly rely on reloading the page or unplugging for hard reset.
        // For now, we just clear the state.
        setUsbPort(null);
        setIsConnected(false);
        setPortInfo('');
    };

    const testConnection = async () => {
        if (!isConnected) {
            alert("Connect USB first!");
            return;
        }
        await sendCommand('pan 90');
        setTimeout(() => sendCommand('tilt 90'), 500);
        alert("Test commands sent (pan 90, tilt 90)");
    };

    return (
        <div className="card">
            <h2>🔌 USB Control</h2>

            <div className="input-group">
                <label>Status</label>
                <div className={`value-display ${isConnected ? 'connected' : 'disconnected'}`}>
                    {isConnected ? '🟢 Connected (Serial)' : '🔴 Disconnected'}
                </div>
            </div>

            {isConnected && (
                <div style={{ padding: '10px', background: 'rgba(0, 0, 0, 0.2)', marginBottom: '10px', borderRadius: '5px' }}>
                    <small>{portInfo}</small>
                </div>
            )}

            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                {!isConnected ? (
                    <button
                        className="button success"
                        onClick={connectUSB}
                    >
                        Connect USB
                    </button>
                ) : (
                    <>
                        <button
                            className="button danger"
                            onClick={disconnectUSB}
                        >
                            Disconnect
                        </button>
                        <button
                            className="button"
                            onClick={testConnection}
                        >
                            Test USB
                        </button>
                    </>
                )}
            </div>

            <div style={{ marginTop: '15px', padding: '10px', background: 'rgba(33, 150, 243, 0.2)', borderRadius: '8px', fontSize: '0.9em' }}>
                <strong>Note:</strong> USB is more stable than Bluetooth.
                <br />Make sure no other app (like Arduino IDE) is using the port.
            </div>
        </div>
    );
}

export default USBControl;
